import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { AppState } from 'store'
import { numberToDisplayString } from 'common/helpers/numberHelpers'
import FullOffertInfoMenu from 'components/FullOffertInfoMenu/FullOffertInfoMenu'
import { FULL_OFFERT_MENU_TYPES } from 'components/FullOffertInfoMenu/FullOffertInfoMenuProps'
import { ISumaryComponentsProps, ISumaryProps } from './SummaryProps'
import FullOffertInfoModal from 'components/FullOffertInfoModal/FullOffertInfoModal'
import useTextContents from 'common/hooks/useTextContents'
import { isTrastiBroker } from 'common/helpers/helpers'

import './SummaryStyles.scss'


const SumaryExtended = (props: ISumaryComponentsProps) => {
   const currentSelectedInstallmentsNumber = props.applicationState.offert.paymentSchedule.filter(singlePaymentSchedule => singlePaymentSchedule.isSelected).length
   const [isOffertModalOpen, setIsOffertModalOpen] = useState<boolean>(false)
   const handleOnMenuClose = useCallback(() => setIsOffertModalOpen(false), [])
   const handleOnMenuOpen = useCallback(() => setIsOffertModalOpen(true), [])

   const { IS_TRASTI, applicationState, summaryTextContents } = props

   return (
      <SummaryBasic applicationState={props.applicationState} summaryTextContents={summaryTextContents} IS_TRASTI={IS_TRASTI} >
         <div className='summary-extended-components-divider' />
         <h4 className='summary-extended-heading'>{summaryTextContents('offerSummaryWidget.extendedSummaryHeader')}</h4>
         {
            !IS_TRASTI ? (
               <div className='summary-column-inner-wrapper'>
                  <p>{summaryTextContents('offerSummaryWidget.extendedSummaryPaymentOnTime')}</p>
                  <p>{numberToDisplayString(applicationState.amountToPay, " zł")}</p>
               </div>
            ) : <span />
         }
         <div className='summary-column-inner-wrapper'>
            <p>{summaryTextContents('offerSummaryWidget.extendedSummaryPaymentAfterTime')}</p>
            <p>{`${currentSelectedInstallmentsNumber} x ${numberToDisplayString(applicationState.offert.instalmentAmount, " zł")}`}</p>
         </div>
         <div className='summary-extended-details-button-wrapper'>
            <p onClick={() => handleOnMenuOpen()} className='summary-extended-details-button'>{summaryTextContents('offerSummaryWidget.detailsButton')}</p>
            <FullOffertInfoModal isOpen={isOffertModalOpen} handleOnClose={handleOnMenuClose} />
         </div>
      </SummaryBasic>
   )
}

const SummaryBasic = (props: ISumaryComponentsProps) => {

   const { IS_TRASTI, applicationState, summaryTextContents } = props
   
   return (
      <aside className='summary-outer-wrapper'>
         <FullOffertInfoMenu menuType={FULL_OFFERT_MENU_TYPES.WALLET} className='summary-top-icon' />
         <div className='summary-column-inner-wrapper' >
            <p>{summaryTextContents('offerSummaryWidget.shortSummaryPayFor')}</p>
            <p>{IS_TRASTI? "Trasti 6x0%" : applicationState.billingCompany}</p>
         </div>
         <div className='summary-column-inner-wrapper' >
            <p>{summaryTextContents('offerSummaryWidget.shortSummaryPayAmount')}</p>
            <p>{numberToDisplayString(applicationState.amountToPay, " zł")}</p>
         </div>
         {props.children}
      </aside>
   )
}

const Summary = (props: ISumaryProps): JSX.Element => {
   const applicationState = useSelector((state: AppState) => state.applicationState)
   const summaryTextContents = useTextContents()

   if(props.isExtended) {
      return <SumaryExtended applicationState={applicationState} summaryTextContents={summaryTextContents} IS_TRASTI={isTrastiBroker()} />
   }
   else {
      return <SummaryBasic applicationState={applicationState} summaryTextContents={summaryTextContents} IS_TRASTI={isTrastiBroker()} />
   }
}

export default Summary